import { FC, ReactNode } from "react";
import EmailPasswordLogin from "./EmailPassword";
import PhoneOTPLogin from "./PhoneOTP";
import { LoginMethod, LoginMethodProps } from "./types";
import { msg } from "@lingui/core/macro";
import { MessageDescriptor } from "@lingui/core";

export const LoginMethodComponentMap: {
  [x in LoginMethod]: {
    component: FC<LoginMethodProps>;
    icon: ReactNode;
    displayName: MessageDescriptor;
  };
} = {
  [LoginMethod.EmailAndPassword]: {
    component: EmailPasswordLogin,
    icon: undefined,
    displayName: msg({
      id: "Auth_login_email_and_password",
      message: "Login with Email",
    }),
  },
  [LoginMethod.PhoneOTP]: {
    component: PhoneOTPLogin,
    icon: undefined,
    displayName: msg({
      id: "Auth_login_phone_otp",
      message: "Login with Phone OTP",
    }),
  },
};

export function isLoginMethod(input: string): input is LoginMethod {
  if (Object.values(LoginMethod).includes(input as LoginMethod)) {
    return true;
  }

  return false;
}
